import axios from 'axios';
import { all, call, put, takeEvery } from 'redux-saga/effects';
import { getHeaderJWT, URL as url } from '../../../store/path';
import { fetchedDownloadData, fetchedDownloadDataWcWi } from './actions';


function* fetchData() {
    yield takeEvery('FETCH_DOWNLOAD_DATA',fetchingData)
  }

function* fetchingData(action){
    const{response, error} = yield call(fetchingDataAPI, action.payload)
    if(response){
        yield put(fetchedDownloadData(action.payload))
        yield call(downloadingData, response)
    }
}

function fetchingDataAPI(data) {
    console.log(getHeaderJWT())
    return axios.post(url+'/report/dms-txns/download', data, getHeaderJWT(), {crossDomain: true, responseType: 'blob'})
    .then(response => ({response}))
}

function downloadingData(response) {
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function() {
            if (this.readyState == 4 && this.status == 200) {
                    var downloadUrl = URL.createObjectURL(xhttp.response);
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = downloadUrl;
                    a.download = "file.xlsx";
                    a.click();
            }
    };
    xhttp.open("GET", url+'/report/dms-txns/download-file/' + response.data, true);
    xhttp.setRequestHeader('X-RLB-DMS-ACC', localStorage.getItem('acc'));
    xhttp.setRequestHeader('Authorization', `Bearer ${localStorage.getItem('user')}`);
    xhttp.responseType = "blob";
    xhttp.send();
}
// function downloadingData(response) {
//       const fileURL = url+'/report/dms-txns/download-file/' + response.data 
//       axios.get(fileURL, getHeaderJWT(), {responseType: 'blob'})
//       .then((resp) => {
//         const downloadUrl = window.URL.createObjectURL(new Blob([resp.data]));
//         const link = document.createElement('a');
//         link.href = downloadUrl;
//         link.setAttribute('download', 'file.xlsx');
//         document.body.appendChild(link);
//         link.click();
//         link.remove();

//         // console.log('After downloading file')
//         // const dfile = new Blob([resp.data], { type: 'vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'})
//         // saveAs(dfile, 'report.xlsx')
//       }, (error) => {
//         console.log("--------Received data Download Signed url ERROR-----------")
//         console.log(error);
//       });
// }

function* fetchWcWiData() {
    yield takeEvery('FETCH_DOWNLOAD_DATA_WC_WI',fetchingWcWiData)
  }

function* fetchingWcWiData(action){
    console.log(action.payload)
    const{response, error} = yield call(fetchingWcWiDataAPI, action.payload)
    if(response){
        console.log(response,'---response')
        yield put(fetchedDownloadDataWcWi(action.payload))
        yield call(downloadingWcWiData, response)
    }
}

function fetchingWcWiDataAPI(data) {
    return axios.post(url+'/report/dms-txns/wiwc-exception', data, getHeaderJWT(), {crossDomain: true, responseType: 'blob'})
    .then(response => ({response}))
}

function downloadingWcWiData(response) {
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function() {
            if (this.readyState == 4 && this.status == 200) {
                    var downloadUrl = URL.createObjectURL(xhttp.response);
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = downloadUrl;
                    a.download = "file.xlsx";
                    a.click();
            }
    };
    xhttp.open("GET", url+'/report/dms-txns/download-file/' + response.data, true);
    xhttp.setRequestHeader('X-RLB-DMS-ACC', localStorage.getItem('acc'));
    xhttp.setRequestHeader('Authorization', `Bearer ${localStorage.getItem('user')}`);
    xhttp.responseType = "blob";
    xhttp.send();
}

const sagaErrorMessage = (error, action) => {
    console.group("Saga Error:"+action.type)
    console.log(error)
    console.groupEnd()
}

export default function* downloadDataSaga() {
    yield all([
        fetchData(),
        fetchWcWiData()
    ])
  }  